// extracted by mini-css-extract-plugin
module.exports = {"recentArticleContainer":"_2FqJ-lQBTTQNYBXEgneWZ2","itemContainer":"_2qxGHAz2hoipcMAbggo_5Q","itemTitle":"_1bLLoX04OXP0m1-FUczNpQ"};